var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail.triglycerides||_vm.detail.lowDensityFat)?_c('div',[_c('base-card',{staticClass:"mt-28",attrs:{"title":"血脂水平分析（mmol/L）"}},[_c('numberCard',{attrs:{"list":_vm.numberList}}),_c('textCard',{staticClass:"mt-40",attrs:{"list":[
                            '根据医学指南：',
                            '甘油三酯目标值为：＜1.7mmol/L',
                            '缺血性卒中及卒中极高危人群：',
                            '低密度脂蛋白胆固醇目标值为＜1.8mmol/L',
                            '卒中高危人群：',
                            '低密度脂蛋白胆固醇目标值为＜2.6mmol/L',
                            '卒中中低危人群：',
                            '低密度脂蛋白胆固醇目标值为＜3.4 mmol/L',
                            '如有疑问，请咨询医生。',
                ]}})],1),_c('remind',{attrs:{"title":"温馨提示","list":_vm.tips}})],1):_c('van-empty',{attrs:{"description":"您本月未记录血脂，无法为您做出分析和建议，建议您在做完血脂检测后，及时上传相关数据，我们将在下月1日为您进行分析、出具血脂数据报告"}})
}
var staticRenderFns = []

export { render, staticRenderFns }